module.exports = __webpack_public_path__ + "img/couponTop.d5d0d882.png";